import { IconButton, Menu, MenuContent, MenuTrigger, MenuItem } from '@cad-arc';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { useSearchUnitHistoryResponse } from '../context/hooks';
import { isUnitHistoryFormValid } from '../is-unit-history-form-valid';
import { UnitHistoryForm } from '../types';
import { useExportUnitHistoryMutation } from '../hooks/use-export-unit-history-mutation';

export function UnitHistoryMoreActionsMenu(): React.ReactElement {
    const searchUnitHistoryResponse = useSearchUnitHistoryResponse();
    const exportUnitHistoryMutation = useExportUnitHistoryMutation();
    const hasResults = !!searchUnitHistoryResponse?.unitHistoryItemsGroups.length;
    const { form } = useIntegratedForm<UnitHistoryForm>();
    const formValues = form.watch();
    const isValid = isUnitHistoryFormValid(formValues);
    return (
        <Menu>
            <MenuTrigger asChild>
                <IconButton variant="ghost" icon="MoreActions" aria-label="more actions" />
            </MenuTrigger>
            <MenuContent>
                <MenuItem
                    onSelect={() => exportUnitHistoryMutation.mutate(form.getValues())}
                    disabled={!hasResults || !isValid}
                >
                    Export to PDF
                </MenuItem>
            </MenuContent>
        </Menu>
    );
}
